import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import { LANDING_ROUTES } from '@/config/routes';
import { hasFeature } from '@/utils/featureFlag';

import { PrivateRoute } from '@/shared/router/PrivateRoute';
import { PublicRoute } from '@/shared/router/PublicRoute';

import Signin from '@/pages/Landing/Login/Signin';
import Signup from '@/pages/Landing/Login/Signup';

const AcceptTerms = lazy(() => import('@/pages/Landing/AcceptTerms/AcceptTerms'));
const Persona = lazy(() => import('@/pages/Landing/Persona/Persona'));
const ProvideEmail = lazy(() => import('@/pages/Landing/ProvideEmail/ProvideEmail'));

export const LandingRoutes = () => {
  return (
    <Switch>
      <Route
        path={LANDING_ROUTES.signin}
        exact
        render={() => (
          <PublicRoute>
            <Signin />
          </PublicRoute>
        )}
      />

      <Route
        path={LANDING_ROUTES.signup}
        exact
        render={() => (
          <PublicRoute>
            <Signup />
          </PublicRoute>
        )}
      />

      <Route
        path={LANDING_ROUTES.persona}
        exact
        render={() => (
          <PrivateRoute>
            <Persona />
          </PrivateRoute>
        )}
      />

      {hasFeature('soundcloudTrackUpload') && (
        <Route path={LANDING_ROUTES.provideEmail} exact>
          <ProvideEmail />
        </Route>
      )}

      <Route path={LANDING_ROUTES.acceptTerms} exact>
        <AcceptTerms />
      </Route>
    </Switch>
  );
};
